/**
 * Constantes de movimento do v2. Sem React de propósito: este módulo
 * é lido também por CSS-in-JS e por componentes que não montam nada.
 * A raiz (LazyMotion + MotionConfig) vive em components/v2/primitives.
 */

export const EASE_CLUB = [0.16, 1, 0.3, 1];

export const DUR = {
  fast: 0.18,
  normal: 0.42,
  slow: 0.9,
};

/** Entrada padrão: sobe 18px e aparece. */
export const variantesReveal = {
  oculto: { opacity: 0, y: 18 },
  visivel: {
    opacity: 1,
    y: 0,
    transition: { duration: DUR.normal * 1.6, ease: EASE_CLUB },
  },
};

/** Container que escalona os filhos. */
export const variantesLista = (intervalo = 0.07) => ({
  oculto: {},
  visivel: { transition: { staggerChildren: intervalo } },
});

/** Manchete palavra por palavra, cada uma subindo de dentro da linha. */
export const variantesPalavra = {
  oculto: { y: '102%' },
  visivel: { y: '0%', transition: { duration: DUR.slow, ease: EASE_CLUB } },
};

/** Quanto da seção precisa entrar na tela para disparar a revelação. */
export const VIEWPORT_REVEAL = { once: true, margin: '0px 0px -12% 0px' };
